import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { getPanels } from '_helpers';
import styles from './Common.module.css';
import { ObservationCircumferenceAtMalleoli } from './ObservationCircumferenceAtMalleoli'
import { ObservationCircumferenceAnkleFigure8 } from './ObservationCircumferenceAnkleFigure8'
import { ObservationCircumferenceNavicular } from './ObservationCircumferenceNavicular'
import { ObservationCircumferenceHand } from './ObservationCircumferenceHand'
import { ObservationCircumference2InchAbove } from './ObservationCircumference2InchAbove'
import { ObservationCircumferenceMidPatella } from './ObservationCircumferenceMidPatella'
import { ObservationCircumference2InchBelow } from './ObservationCircumference2InchBelow'
import { ObservationCircumferenceStageOfLymphedema } from './ObservationCircumferenceStageOfLymphedema'
import { ObservationCircumferenceOther } from './ObservationCircumferenceOther'

const components = {
    ObservationCircumferenceAtMalleoli,
    ObservationCircumferenceAnkleFigure8,
    ObservationCircumferenceNavicular,
    ObservationCircumferenceHand,
    ObservationCircumference2InchAbove,
    ObservationCircumferenceMidPatella,
    ObservationCircumference2InchBelow,
    ObservationCircumferenceStageOfLymphedema,
    ObservationCircumferenceOther
}

class PatientCareCenterNoteObjectiveObsCircum extends React.Component {

    renderChild(name, mopno) {
        const Child = components[name];
        return Child === undefined ? <span key={name} mopno={mopno} /> : <Child key={name} mopno={mopno} />;
    }

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSection id='obj_obs_circum' name='Circumference Measurements' level={2} noChildPadding={true}>
                    <div className={styles.row}>
                        <span className={styles.flag} />
                        <span className={styles.label} />
                        <label className={styles.circum_column} >R</label>
                        <label className={styles.circum_column} >L</label>
                    </div>
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return this.renderChild(this.props.panels[key].MOPNAME, this.props.panels[key].MOPNO);
                            })

                    }
                </PatientCareCenterNoteSection>
            );
        } else {
            return (
                <span />
            )
        }
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        noteId: noteId,
        panels: getPanels(noteId, 'Observation', 'Circumference')
    };
}

const connectedPatientCareCenterNoteObjectiveObsCircum = connect(mapStateToProps)(PatientCareCenterNoteObjectiveObsCircum);
export { connectedPatientCareCenterNoteObjectiveObsCircum as PatientCareCenterNoteObjectiveObsCircum };

